// extracted by mini-css-extract-plugin
export default {"container":"Container_container__MM274","title":"Container_title__0mdA7"};